'use client';
import styled from 'styled-components';

export const BreadcrumbContainer = styled.div`
  background: ${props => props.theme.colors.background.base};
  width: 50%;
  margin-right: ${props => props.theme.spacing(2)};
  padding-right: ${props => props.theme.spacing(2)};

  @media ${props => props.theme.mobile} {
    margin-top: ${props => props.theme.spacing(2)};
  }

  @media ${props => props.theme.tablet} {
    width: 20%;
    padding: ${props => props.theme.spacing(4, 6, 2, 0)};
    margin-right: ${props => props.theme.spacing(6)};
    margin-top: 0;
  }
`;

export const CurrentProgress = styled.h3`
  ${props => props.theme.typography.subheading1}
  color: ${props => props.theme.colors.text.tertiary};
  margin-bottom: ${props => props.theme.spacing(1.5)};
  text-align: right;
  text-transform: uppercase;
`;

export const PromoPillContainer = styled.div`
  position: fixed;
  top: ${props => props.theme.spacing(6)};
  right: ${props => props.theme.spacing(10)};
  @media ${props => props.theme.laptop} {
    right: ${props => props.theme.spacing(20)};
  }
`;
